import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/features/image-to-video-ai" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/image-to-video-ai" element={<AsyncPage />} />
  </Route>
);
